import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { ConfiguracionRoutingModule } from './routing';
import { ListadoMarkersComponent } from './vehiculos/listado-markers/listado-markers.component';
import { CrearEditarMarkerComponent } from './vehiculos/crear-editar-marker/crear-editar-marker.component';

@NgModule({
  declarations: [CrearEditarMarkerComponent, ListadoMarkersComponent],
  imports: [CommonModule, AuxiliaresModule, ConfiguracionRoutingModule],
})
export class ConfiguracionModule {}
